import {LogLevel, PublicClientApplication} from '@azure/msal-browser'

export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_CLIENT_ID as string, // Aquí va el clientId correcto de la aplicación.
    authority: process.env.REACT_APP_AUTHORITY,
    redirectUri: process.env.REACT_APP_REDIRECT_URL, // Se puede cambiar la url de re dirección si es necesario.
  },
  cache: {
    cacheLocation: process.env.REACT_APP_CACHE_LOCATION as 'localStorage' | 'sessionStorage', // Se puede optar por "localStorage" o 'sessionStorage'.
    storeAuthStateInCookie: false, // Se debe poner en true si se tiene problemas con cookies en IE.
  },
  system: {
    loggerOptions: {
      loggerCallback: (level: any, message: any, containsPii: any) => {
        if (containsPii) return

        switch (level) {
          case LogLevel.Error:
            console.error(message)
            return
          case LogLevel.Info:
            console.info(message)
            return
          case LogLevel.Verbose:
            console.debug(message)
            return
          case LogLevel.Warning:
            console.warn(message)
            return
          default:
            return
        }
      },
    },
  },
}

export const msalInstance = new PublicClientApplication(msalConfig)
